import type { OilViscosityParameters } from "../../d";

// returns mu_o cP
export function deadOilViscosityCalculator(params: OilViscosityParameters): {
  deadOilViscosity: number;
} {
  const { temperatureF, oilAPI } = params;

  // Q118: =(16*10**8)*(D4**-2.8177)*(LOG10(D7))**(5.7526*LOG10(D4)-26.9718)
  const deadOilViscosity =
    16 *
    10 ** 8 *
    temperatureF ** -2.8177 *
    Math.log10(oilAPI) ** (5.7526 * Math.log10(temperatureF) - 26.9718);
  return {
    deadOilViscosity
  };
}
